import React from 'react';
import { Collapse } from 'antd';
import { popupLink, infoLink } from './ScenarioCompareNested';
import UseBktGrid from '../UseBktGrid';

export const getMeta = (item, dataTypeOptions) => dataTypeOptions
  .find(options => (options.item_type === item));

const ScenarioCompareDataView = ({
  dataViewForData,
  dataType,
  dataTypeOptions,
  gridConfigForData,
}) => (
  <Collapse bordered={false}>
    {
      (
        dataViewForData.loadingQueue.length === 0
        && dataViewForData.data.data
      ) && (
        Object.values(dataViewForData.data.data.categories).map((item) => {
          let showData = item.data;
          const meta = {
            ...getMeta(dataType, dataTypeOptions),
          };
          const similarMatchData = [];
          if (item.dataType === 'match') {
            showData = item.data.map(innerItem => innerItem[0]);
          }

          if (item.dataType === 'similar') {
            const newShowData = [];

            item.data.forEach((innerItem, i) => {
              const newInnerItem1 = { ...innerItem[0] };
              const newInnerItem2 = { ...innerItem[1] };

              // The current setup is putting the pair in 2 rows.
              newShowData.push(newInnerItem1, newInnerItem2);
              similarMatchData.push(item.differenceFields[i], item.differenceFields[i]);
            });

            showData = newShowData;

            const haveInfoCol = meta.columns && meta.columns.find(col => col.name === 'difference');
            if (!haveInfoCol && meta.columns) {
              meta.columns.push({
                name: 'difference', display_name: 'Info', type: 'info',
              });
            }
          }

          return (
            <Collapse.Panel
              header={`${item.heading} (${item.count})`}
              key={item.heading}
            >
              <UseBktGrid
                data={showData}
                meta={meta}
                config={gridConfigForData}
                onNested={(title, data) => popupLink(
                  title, data, dataTypeOptions, gridConfigForData,
                )}
                height="30vh"
                {...(item.dataType === 'similar') && {
                  useSimilarMatches: similarMatchData,
                  className: 'DCRPScenarioCompareSimilarGrid',
                  onInfo: data => infoLink(data),
                }}
              />
            </Collapse.Panel>
          );
        })
      )
    }
  </Collapse>
);

export default ScenarioCompareDataView;
